<div class="container-fluid widget-wrapper" #widgetHeader>
  <div class="row widget-header" [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2><span>Risk Overview</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
          data-animation="false" title="Pixalate's unique advertising risk assessment based on blended risk factors
                          including brand safety, invalid traffic and ad inventory.">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon" />
        </a>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body p-lg-0">
    <div class="col-lg-12 px-0">
      <app-ctv-overview-risk [data]="data" [byRegionsData]="data?.riskOverview?.byRegion" [isFreemium]="isFreemium"
        [isFollowing]="isFollowing" (anchorClick)="anchorClick.emit($event)"
        (goToDiscovery)="toAppDiscovery.emit($event)" (followClick)="followButtonClick.emit($event)">
      </app-ctv-overview-risk>
    </div>
  </div>
</div>
